import * as colors from '@giphy/colors'
import styled from 'styled-components'

export default styled.div`
    background: ${colors.giphyBlack};
    overflow: hidden;
    position: absolute;
    transform-origin: 100% 0;

    &:before {
        background: no-repeat url(${(props) => props.image}) center center;
        background-size: contain;
        content: '';
        display: block;
        height: 100%;
        width: 100%;
    }
`
